import React, { useRef } from 'react';
import cn from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { createPortal } from 'react-dom';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import useBodyScrollLock from '../../hooks/useBodyScrollLock';

type ModalProps = {
  showModal: boolean;
  onClose: () => void;
  customClass: string;
  children?: React.ReactNode;
  dontClose?: boolean;
}

const Modal = (props: ModalProps) => {
  const { showModal, onClose, customClass = '', children, dontClose = false } = props;
  const modalBodyRef = useRef<HTMLDivElement>(null);
  const modalOverlayRef = useRef<HTMLDivElement>(null);
  const modalPortal = document.getElementById('modal-portal');

  useOnClickOutside(modalBodyRef, dontClose ? (() => false) : onClose);
  useBodyScrollLock({ condition: showModal, mobileOnly: false });

  if (!modalPortal) {
    return null;
  }

  return createPortal(
    <CSSTransition
      in={showModal}
      timeout={300}
      classNames="hf-modal-animate"
      unmountOnExit
      mountOnEnter
      nodeRef={modalOverlayRef}
    >
      <div ref={modalOverlayRef} className={cn("hf-modal-overlay", { [customClass]: customClass })}>
        <div className="hf-modal modal-body flex flex-col" ref={modalBodyRef}>
          {!dontClose &&
            <div className="close-modal cursor-pointer" onClick={onClose} aria-label="Close">
              <i className="ri-close-line text-xl leading-none" />
            </div>
          }
          <div className="hf-modal-content">
            {children}
          </div>
        </div>
      </div>
    </CSSTransition>,
    modalPortal
  );
};

export default Modal;
